import Vue from 'vue'

Vue.prototype.isContains=function(word,arry) {
    const list=arry?arry:[];
    return list.some((item,i)=>{
        if(item == word){
            return true
        }
    })
};


export default {
    timeToCompare(start,end,type){
        const startNew= Date.parse(new Date(`2021/01/01 ${start}`))
        const endNew= Date.parse(new Date(`2021/01/01 ${end}`))
        if(type=='end'){
            if(endNew<startNew){
                return false
            }else{
                return true
            }
        }
    },
    alert(titles, msg, type){
        Vue.prototype.$message ({
            showClose: true,
            message: msg,
            type: type,
            duration:3000
        })
    },
    loadings(n) {
        Vue.prototype.$loading({
            lock: true,
            text: '',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.4)',
            target: document.querySelector('body')
        });
        if(n == 2) {
            var loading = Vue.prototype.$loading({});
            loading.close()
        }
    },
    getPrice (val) {
        if(val){
          let price=+val
          price=val.toFixed(2)
          val=price
        }
        let check = val?val:''
        let pos_decimal =String(check).split('.')
        let check_ = pos_decimal[1]?pos_decimal[1].length:undefined
        let check_2 = pos_decimal[0]?pos_decimal[0]:'0'
        let backtime = ''
        if (check_== undefined) {
            backtime = (check_2+'.00').trim()
        }else if (check_ == 1){
            backtime = pos_decimal.join('.')+'0'
        }else if (check_ == 2){
            backtime = pos_decimal.join('.')
        }else{
            let arr=pos_decimal[1].split('')
            backtime=check_2+'.'+arr[0]+arr[1]
        }
        return String(backtime)
    },
    timeFormat(val){
        if(val.toString().split('').length==10){
            val=Number(val)*1000
        }
        let date=(new Date(val));
        if(!date){
            date=Date.now()
        }
        const time=date.toTimeString().substr(0, 8) + ' '+ date.toLocaleDateString().replace(/\//g, "/") 
        return time
    },
    timestampToTime(timestamp) {
        let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '';
        let M=date.toString().split(' ')[1]+' '
        let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
        let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
        if(H -12 < 0){ 
            H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM'; 
        }else if(H-12>=0 && H-24<0){ 
            H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM'; 
        }else if(H-24 ==0){ 
            H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM'; 
        }
        return D+M+Y;
    },
    timestampToTimeNew(timestamp) {
        if (typeof(timestamp) === 'string')
            timestamp = Number(timestamp)
        if (timestamp < 10000000000)
            timestamp = timestamp * 1000 
        let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear();
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
        let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
        //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
        let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
        if(H -12 <0){ 
            H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM'; 
        }else if(H-12>0 && H-24<0){ 
            H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM'; 
        }else if(H-24 ==0){ 
            H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM'; 
        }else if(H-12 ==0){ 
          H ='12' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM'; 
        }
        // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
        return H+' '+D+M+Y;
    },
    timeFormatTem(val){
        let date=new Date(val*1000);
        if(!date){
            date=Date.now()
        }
        const time=date.toLocaleDateString().replace(/\//g, "/") + " " + date.toTimeString().substr(0, 5)
        return time
    },
    timeFotmatYMD(time){
        let date=new Date(time);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        if(m<10){
            m=`0${m}`
        }
        let d = date.getDate();
        if(d<10){
            d=`0${d}`
        }
        return `${d}/${m}/${y}`
    },
    timeFormatYear(val){
        let date=new Date(val*1000);
        if(!date){
            date=Date.now()
        }
        const time=date.toLocaleDateString().replace(/\//g, "/")
        return time
    },
    getWeek(val){
        let week=''
        switch (val) {
            case 1:
                week='周一'    
            break;
            case 2:
                week='周二'    
            break;
            case 3:
                week='周三'    
            break;
            case 4:
                week='周四'    
            break;
            case 5:
                week='周五'    
            break;
            case 6:
                week='周六'    
            break;
            case 7:
                week='周日'    
            break;
            default:
                week='周一'
            break;
        }
        return week
    },
    getNowDate() {//获取当前时间
        let date = new Date();
        let seperator1 = "-";
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        let currentdate = year + seperator1 + month + seperator1 +strDate;
        return currentdate;
    },
    formatSplit (s, type) {
          if (s== 0) {
            return "0.00";
          }
          if (!s) {
            return null
          }
          if (s == null || s == "") {
            return '';
          }
          if (JSON.stringify(s).indexOf('.') === -1) {
            type = 0
          }
          s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
          s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
          s = s.replace(".", ",");
          var re = /(\d)(\d{3},)/;
          while (re.test(s))
            s = s.replace(re, "$1,$2");
          s = s.replace(/,(\d\d)$/, ".$1");
          if (type == 0) {// 不带小数位(默认是有小数位)
            var a = s.split(".");
            if (a[1] == "00") {
              s = a[0];
            }
          }
          if (s.indexOf('.') === -1)
            s = s + '.00'
          return s;
    },
    formatdateminute (date) {
        if(!date){
            return 'select time'
        }
        date = new Date(date)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        if (m == 1) {
            m = 'Jan'
        } else if (m == 2) {
            m = 'Feb'
        } else if (m == 3) {
            m = 'Mar'
        } else if (m == 4) {
            m = 'Apr'
        } else if (m == 5) {
            m = 'May'
        } else if (m == 6){
            m = 'June'
        } else if (m == 7) {
            m = 'July'
        } else if (m == 8) {
            m = 'Aug'
        } else if (m == 9) {
            m = 'Sept'
        } else if (m == 10) {
            m = 'Oct'
        } else if (m == 11) {
            m = 'Nov'
        } else {
            m = 'Dec'
        }
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return d + ' ' + m + ' ' + y;
    },
    formatVersionTime (date) {
        if(!date){
            return ''
        }
        date = new Date(date)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
        if(H -12 < 0){ 
            H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' am'; 
        }else if(H-12>=0 && H-24<0){ 
            H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' pm':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' pm'; 
        }else if(H-24 ==0){ 
            H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' pm'; 
        }
        if (m == 1) {
            m = 'Jan'
        } else if (m == 2) {
            m = 'Feb'
        } else if (m == 3) {
            m = 'Mar'
        } else if (m == 4) {
            m = 'Apr'
        } else if (m == 5) {
            m = 'May'
        } else if (m == 6){
            m = 'June'
        } else if (m == 7) {
            m = 'July'
        } else if (m == 8) {
            m = 'Aug'
        } else if (m == 9) {
            m = 'Sept'
        } else if (m == 10) {
            m = 'Oct'
        } else if (m == 11) {
            m = 'Nov'
        } else {
            m = 'Dec'
        }
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return H + ' ' + d + ' ' + m + ' ' + y;
    }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js